import {styled} from '@mui/material/styles';

export const StyledDrawerNav = styled('div')({
    display: 'block',
    flexGrow: 1,
    boxShadow: 'none',
    width: '100%',
    minWidth: '15rem',
    paddingLeft: 0,
    paddingRight: 0
});
